import {isPlainObject} from 'rlink-type-utils';
/**
 * Returns the keys iterator for the given object, or an iterator
 * that ends immediately if the object does not have keys (e.g. a
 * Set).
 *
 * @param  {IterableCollection} obj
 * @return {Iterator}
 */
export default function keys (obj) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot iterate non-iterable object: ${obj}`);
  }
  if ( typeof obj.keys === 'function') {
    return obj.keys();
  } else if (isPlainObject(obj)) {
    return Object.keys(obj);
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/keys.js